(() => {
  if (window.palmayardCartBridgeReady) return;
  window.palmayardCartBridgeReady = true;
  let returnFocus;
  document.addEventListener('click', async (event) => {
    const trigger = event.target.closest('#cart-icon-bubble');
    if (!trigger || document.querySelector('[data-cart-mode]')?.dataset.cartMode !== 'drawer') return;
    const cart = window.Alpine?.store('global');
    if (!cart) return;
    event.preventDefault();
    returnFocus = trigger;
    trigger.setAttribute('aria-expanded', 'true');
    cart.isMinicartVisible = true;
    try { await cart.refreshCart(); } catch (error) { console.warn('Cart refresh failed', error); }
  });
  const init = () => {
    const trigger = document.getElementById('cart-icon-bubble');
    const panel = document.getElementById('CommerceCartDrawer');
    const cart = window.Alpine?.store('global');
    if (!panel || !cart) return;
    trigger?.setAttribute('aria-controls', panel.id);
    trigger?.setAttribute('aria-expanded', 'false');
    let previouslyOpen = false;
    window.Alpine.effect(() => {
      const open = cart.isMinicartVisible;
      document.body.classList.toggle('commerce-cart-is-open', open);
      if (cart.cart) {
        const count = cart.cartItemCount;
        const bubble = trigger?.querySelector('.cart-count-bubble');
        if (bubble) {
          bubble.hidden = count === 0;
          bubble.querySelector('[data-cart-count-number]').textContent = count < 100 ? String(count) : '';
          bubble.querySelector('[data-cart-count-label]').textContent = (count === 1 ? bubble.dataset.countOne : bubble.dataset.countMany).replace('[count]', String(count));
        }
      }
      trigger?.setAttribute('aria-expanded', String(open));
      if (open && !previouslyOpen) {
        const active = document.activeElement;
        if (active && active !== document.body && active !== document.documentElement && !panel.contains(active)) {
          returnFocus = active;
        }
        if (!returnFocus?.isConnected) returnFocus = document.getElementById('cart-icon-bubble');
        requestAnimationFrame(() => panel.focus({ preventScroll: true }));
      } else if (!open && previouslyOpen) {
        // Wait for Alpine's focus trap to release before restoring the trigger.
        requestAnimationFrame(() => {
          const target = returnFocus?.isConnected ? returnFocus : document.getElementById('cart-icon-bubble');
          target?.focus?.({ preventScroll: true });
        });
      }
      previouslyOpen = open;
    });
  };
  if (window.Alpine?.store('global')) init();
  else document.addEventListener('alpine:initialized', init, { once: true });
})();
